import { render, staticRenderFns } from "./pesoParaLaTallaNinos2a5A.vue?vue&type=template&id=0875c5b0&scoped=true&"
import script from "./pesoParaLaTallaNinos2a5A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaTallaNinos2a5A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaTallaNinos2a5A.vue?vue&type=style&index=0&id=0875c5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875c5b0",
  null
  
)

export default component.exports